import { Level, Step } from './';

export interface DataSelectionType {
  level: Level;
  step: Step;
  name: string;
}

interface RateRecCategoryOptions {
  [key: string]: DataSelectionType[];
}

export const rateRecCategoryOption = (rateRecCategoryName: string | undefined): DataSelectionType[] => {
  const rateRecCategoryOptions: RateRecCategoryOptions = {
    'Changes in Unrecognized Tax Benefits': [
      { level: 'federal', step: 'credits', name: 'Federal - Credits' },
      { level: 'federal', step: 'tax-effected', name: 'Federal - Tax-Effected' }
    ],
    'Effect of Cross-Border Tax Laws': [
      { level: 'federal', step: 'credits', name: 'Federal - Credits' },
      { level: 'federal', step: 'permanent', name: 'Federal - Permanent Adjustment' },
      { level: 'federal', step: 'tax-effected', name: 'Federal - Tax-Effected' }
    ],
    default: []
  };

  return rateRecCategoryOptions?.[rateRecCategoryName ?? 'default'] || [];
};
